/**
 * Info Viewer Modal - Getabbtes PDF-Anzeige-Modal
 *
 * Leichtgewichtiges Modal zum Anzeigen von Auktionsinformationen
 * und Versteigerungsbedingungen als PDFs mit Tab-Navigation.
 * Nutzt iframe mit Browser-eigenem PDF-Viewer fuer korrekte Font-Darstellung.
 *
 * @package Brandner_Custom
 * @since 1.3.0
 */

(function() {
    'use strict';

    var isOpen = false;
    var modalEl = null;
    var currentTab = null;
    var tabs = {};
    var isCombinedMode = false;

    // pdf.js (gleiche Version wie terms-acceptance)
    // pdf.js — lokal ausgeliefert (assets/vendor/pdfjs/), Begruendung siehe
    // terms-acceptance.js. Fallback aufs CDN, falls die URL nicht durchgereicht wird.
    var PDFJS_VERSION = '3.11.174';
    var PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VERSION;
    var PDFJS_LOCAL = ((window.brandnerTerms || {}).pdfjsUrl || '').replace(/\/$/, '');
    var PDFJS_BASE = PDFJS_LOCAL || PDFJS_CDN;
    var PDFJS_CMAP_URL = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@' + PDFJS_VERSION + '/cmaps/';
    var PDFJS_FONT_URL = PDFJS_LOCAL
        ? PDFJS_LOCAL + '/standard_fonts/'
        : 'https://cdn.jsdelivr.net/npm/pdfjs-dist@' + PDFJS_VERSION + '/standard_fonts/';
    var pdfjsLoaded = false;
    var fontDataOk = null;

    /**
     * Prueft einmalig, ob die Glyphen-Daten erreichbar sind — siehe
     * terms-acceptance.js. Ohne sie wuerde disableFontFace eine textlose
     * Seite rendern, dann lieber zurueck auf die Browser-Schriftmaschinerie.
     */
    function checkFontData() {
        if (fontDataOk !== null) {
            return Promise.resolve(fontDataOk);
        }
        if (!window.fetch) {
            fontDataOk = false;
            return Promise.resolve(false);
        }
        return fetch(PDFJS_FONT_URL + 'LiberationSans-Regular.ttf', { method: 'HEAD' })
            .then(function(r) { fontDataOk = !!r.ok; return fontDataOk; })
            .catch(function() { fontDataOk = false; return false; });
    }

    /**
     * pdf.js dynamisch vom CDN laden (wiederverwendet falls terms-acceptance es schon geladen hat)
     */
    function loadPdfJs() {
        return new Promise(function(resolve, reject) {
            if (pdfjsLoaded && window.pdfjsLib) {
                resolve();
                return;
            }
            if (window.pdfjsLib) {
                pdfjsLoaded = true;
                resolve();
                return;
            }
            var script = document.createElement('script');
            script.src = PDFJS_BASE + '/pdf.min.js';
            script.onload = function() {
                if (window.pdfjsLib) {
                    window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + '/pdf.worker.min.js';
                    pdfjsLoaded = true;
                    resolve();
                } else {
                    reject(new Error('pdfjsLib not available after script load'));
                }
            };
            script.onerror = function() {
                reject(new Error('Failed to load pdf.js from CDN'));
            };
            document.head.appendChild(script);
        });
    }

    /**
     * Modal-HTML erstellen
     */
    function createModal() {
        if (document.getElementById('brandner-info-viewer-modal')) return;

        var div = document.createElement('div');
        div.className = 'brandner-info-viewer-overlay';
        div.id = 'brandner-info-viewer-modal';
        div.innerHTML =
            '<div class="brandner-info-viewer-modal">' +
                '<div class="brandner-info-viewer-header">' +
                    '<div class="brandner-info-viewer-tabs" id="info-viewer-tabs"></div>' +
                    '<div class="brandner-info-viewer-header-right">' +
                        '<a class="brandner-info-viewer-newtab" id="info-viewer-newtab" href="#" target="_blank" rel="noopener" title="In neuem Tab oeffnen">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                                '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>' +
                                '<polyline points="15 3 21 3 21 9"/>' +
                                '<line x1="10" y1="14" x2="21" y2="3"/>' +
                            '</svg>' +
                        '</a>' +
                        '<button type="button" class="brandner-info-viewer-close" id="info-viewer-close" aria-label="Schliessen">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                                '<line x1="18" y1="6" x2="6" y2="18"/>' +
                                '<line x1="6" y1="6" x2="18" y2="18"/>' +
                            '</svg>' +
                        '</button>' +
                    '</div>' +
                '</div>' +
                '<div class="brandner-info-viewer-body loading" id="info-viewer-body">' +
                    '<div class="brandner-info-viewer-pdf-container" id="info-viewer-pdf"></div>' +
                '</div>' +
            '</div>';

        document.body.appendChild(div);
        modalEl = div;

        // Events binden
        document.getElementById('info-viewer-close').addEventListener('click', closeModal);
        div.addEventListener('click', function(e) {
            if (e.target === div) closeModal();
        });
    }

    /**
     * Modal oeffnen
     */
    function openModal(tabsConfig, activeTab) {
        createModal();
        tabs = tabsConfig;
        isOpen = true;
        document.body.classList.add('brandner-info-viewer-open');

        // Tabs rendern
        var tabsContainer = document.getElementById('info-viewer-tabs');
        tabsContainer.innerHTML = '';

        var tabKeys = Object.keys(tabs);

        // Titel immer "Auktionsbedingungen"
        var titleEl = document.createElement('h3');
        titleEl.className = 'brandner-info-viewer-single-title';
        titleEl.textContent = 'Auktionsbedingungen';
        tabsContainer.appendChild(titleEl);

        modalEl.classList.add('active');

        if (tabKeys.length >= 2) {
            // Mehrere PDFs: nahtlos kombiniert rendern (kein Tab)
            isCombinedMode = true;
            // "In neuem Tab"-Link verstecken (kein sinnvolles Einzelziel)
            document.getElementById('info-viewer-newtab').style.display = 'none';
            var urls = tabKeys.map(function(key) { return tabs[key].url; });
            renderCombinedPdfs(urls);
        } else {
            // Ein PDF: iframe wie bisher
            isCombinedMode = false;
            document.getElementById('info-viewer-newtab').style.display = '';
            switchTab(activeTab || tabKeys[0]);
        }
    }

    /**
     * Tab wechseln
     */
    function switchTab(tabKey) {
        if (!tabs[tabKey]) return;
        currentTab = tabKey;

        // Tab-Buttons aktualisieren
        var allTabs = document.querySelectorAll('.brandner-info-viewer-tab');
        allTabs.forEach(function(el) {
            el.classList.toggle('active', el.getAttribute('data-tab') === tabKey);
        });

        // "In neuem Tab"-Link aktualisieren
        document.getElementById('info-viewer-newtab').href = tabs[tabKey].url;

        // PDF rendern
        renderPdf(tabs[tabKey].url);
    }

    /**
     * PDF im iframe rendern (Browser-eigener PDF-Viewer fuer korrekte Font-Darstellung)
     */
    function renderPdf(url) {
        var container = document.getElementById('info-viewer-pdf');
        var body = document.getElementById('info-viewer-body');
        container.innerHTML = '';
        body.classList.add('loading');

        var iframe = document.createElement('iframe');
        iframe.src = url + '#toolbar=0';
        iframe.style.cssText = 'width:100%;height:100%;border:none;';
        iframe.title = 'PDF Dokument';

        iframe.addEventListener('load', function() {
            body.classList.remove('loading');
        });
        setTimeout(function() {
            body.classList.remove('loading');
        }, 5000);

        container.appendChild(iframe);
    }

    /**
     * Mehrere PDFs nahtlos hintereinander in den Container rendern (pdf.js)
     */
    function renderCombinedPdfs(urls) {
        var container = document.getElementById('info-viewer-pdf');
        var body = document.getElementById('info-viewer-body');
        container.innerHTML = '';
        container.scrollTop = 0;
        container.classList.add('scroll-mode');
        body.classList.add('loading');

        loadPdfJs().then(checkFontData).then(function(glyphenVerfuegbar) {
            var chain = Promise.resolve();

            urls.forEach(function(url) {
                chain = chain.then(function() {
                    return window.pdfjsLib.getDocument({
                        url: url,
                        cMapUrl: PDFJS_CMAP_URL,
                        cMapPacked: true,
                        standardFontDataUrl: PDFJS_FONT_URL,
                        // Glyphen als Vektorpfade zeichnen statt per @font-face,
                        // siehe terms-acceptance.js
                        disableFontFace: glyphenVerfuegbar
                    }).promise;
                }).then(function(pdf) {
                    var pageChain = Promise.resolve();
                    for (var i = 1; i <= pdf.numPages; i++) {
                        (function(pageNum) {
                            pageChain = pageChain.then(function() {
                                return pdf.getPage(pageNum);
                            }).then(function(page) {
                                var containerWidth = container.clientWidth - 16;
                                var viewport = page.getViewport({ scale: 1 });
                                var scale = containerWidth / viewport.width;
                                var dpr = window.devicePixelRatio || 1;
                                var cssViewport = page.getViewport({ scale: scale });
                                var renderViewport = page.getViewport({ scale: scale * dpr });

                                var canvas = document.createElement('canvas');
                                canvas.className = 'terms-pdf-page';
                                canvas.width = renderViewport.width;
                                canvas.height = renderViewport.height;
                                canvas.style.width = cssViewport.width + 'px';
                                canvas.style.height = cssViewport.height + 'px';
                                container.appendChild(canvas);

                                var ctx = canvas.getContext('2d');
                                ctx.fillStyle = '#ffffff';
                                ctx.fillRect(0, 0, renderViewport.width, renderViewport.height);
                                return page.render({
                                    canvasContext: ctx,
                                    viewport: renderViewport,
                                    background: 'rgba(255, 255, 255, 1)'
                                }).promise;
                            });
                        })(i);
                    }
                    return pageChain;
                });
            });

            return chain;
        }).then(function() {
            body.classList.remove('loading');
        }).catch(function(err) {
            console.error('[Brandner Info Viewer] PDF render error:', err);
            body.classList.remove('loading');
            // Fallback: iframe mit erstem PDF
            container.classList.remove('scroll-mode');
            renderPdf(urls[0]);
        });
    }

    /**
     * Modal schliessen
     */
    function closeModal() {
        isOpen = false;
        isCombinedMode = false;
        document.body.classList.remove('brandner-info-viewer-open');
        var container = document.getElementById('info-viewer-pdf');
        if (container) {
            container.innerHTML = '';
            container.classList.remove('scroll-mode');
        }
        if (modalEl) {
            modalEl.classList.remove('active');
        }
        // "In neuem Tab"-Link wieder sichtbar machen fuer naechsten Aufruf
        var newtab = document.getElementById('info-viewer-newtab');
        if (newtab) newtab.style.display = '';
        currentTab = null;
        tabs = {};
    }

    /**
     * ESC-Taste zum Schliessen
     */
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isOpen) {
            closeModal();
        }
    });

    /**
     * Click-Handler via Event Delegation
     */
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.brandner-info-viewer-btn');
        if (!btn) return;

        e.preventDefault();

        var auktionsinfoUrl = btn.getAttribute('data-auktionsinfo-url');
        var agbUrl = btn.getAttribute('data-agb-url');
        var activeTab = btn.getAttribute('data-info-tab') || 'auktionsinfo';

        var tabsConfig = {};
        if (auktionsinfoUrl) {
            tabsConfig.auktionsinfo = {
                label: 'Auktionsinformationen',
                url: auktionsinfoUrl
            };
        }
        if (agbUrl) {
            tabsConfig.agb = {
                label: 'Versteigerungsbedingungen',
                url: agbUrl
            };
        }

        if (Object.keys(tabsConfig).length === 0) return;

        openModal(tabsConfig, activeTab);
    });

})();
